var siteNav = (function () {

  toggle = $(".js-menu-toggle");
  menu = $(".js-menu");
  header = $(".header");
  collapse = $(".menu-item-has-children");
  searchToggle = $(".js-search-toggle");
  shareToggle = $(".js-share-toggle");
  resourceCategoryToggle = $(".js-resource-category-toggle");

  function showNav() {
    menu.addClass('nav-open');
    $("body").addClass('nav-open');
    window.setTimeout(function () { $('body').addClass('no-scroll'); }, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done
    $('.nav--main a').attr('tabindex', ''); // links inside navigation should be TAB selectable
  }

  function hideNav() {
    menu.removeClass('nav-open');
    $("body").removeClass('nav-open');
    window.setTimeout(function () { $('body').removeClass('no-scroll'); }, 10); // allow animations to start before removing class (Firefox)
    $('.nav--main a').attr('tabindex', '-1'); // links inside hidden navigation should not be TAB selectable
  }

  function showHideNav() {
    if ($(".js-menu").hasClass('nav-open')) {
      hideNav();
    } else {
      showNav();
    }
  }

  // Shows/hides navigation’s popover if class "expanded"
  toggle.on('click touchstart', function (event) {
    showHideNav();
    event.preventDefault();
  });

  $(".menu-item-has-children > a").on('click', function (event) {
    var width = $(window).width();
    if (width < 1400) {
      event.preventDefault();
      $(this).parent().toggleClass("collapsed");
    }
  });

  // Mobile Dropdown Toggle
  $(".gs-mobile-dropdown-toggle").on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass("collapsed");
    $(this).next().toggleClass("d-block");
  });
})();